import moment from "moment/moment";
import $ from 'jquery';
import XLSX from 'xlsx';
import _ from 'lodash';


class SpringDataTableController {
  constructor($scope, $rootScope, $http, $sce, toastr, $timeout, $q) {
    "ngInject";
    let self = this;
    this.name = 'springDataTable';
    this.scope = $scope;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.$sce = $sce;
    this.toastr = toastr;
    this.$timeout = $timeout;
    this.$q = $q;
    this.pageSize = 0;
    this.totalRecordCount = 0;
    this.displayPageNumber = 1;
    this.pageNumber = 0;
    this.numPages = 0;
    this.tabledata = [];
    this.exporting = false;
    this.allSelected = false;
    this.someSelected = false;
    // this.recordSize = "25";

    setInterval(function () {
      if(self.filterrefresh) {
        self.loadData();
        self.filterrefresh = false;
      }
    }, 200);

    // Close filter dropdowns when clicking outside
    $(document).on('click', function(event) {
      const target = $(event.target);
      const clickedFilterIcon = target.closest('.fa-filter').length > 0 || target.hasClass('fa-filter');
      const clickedInsideDropdown = target.closest('.column-filter-dropdown').length > 0;
      
      // Only close if not clicking on filter icon or inside dropdown
      if(!clickedFilterIcon && !clickedInsideDropdown) {
        if(self.columns) {
          self.columns.forEach(function(column) {
            column.showFilter = false;
          });
          // Trigger digest cycle to update the view
          if(self.scope && !self.scope.$$phase) {
            self.scope.$apply();
          }
        }
      }
    });

    // Watch for tabledata changes when using client-side data
    $scope.$watch(function() {
      return self.tabledata;
    }, function(newVal, oldVal) {
      if(newVal && newVal !== oldVal && (!self.restUrl || self.restUrl === '')) {
        self.loadClientSideData();
      }
    }, true);

    self.$onInit = function () {
      self.$timeout(function() {
        if (self.defaultSort) {
          self.sortBy = self.defaultSort;
        }
        self.loadData();
      }, 0);
    }
  }

  loadClientSideData() {
    let self = this;
    self.loading = true;

    if(!self.tabledata || self.tabledata.length === 0) {
      self.data = [];
      self.numPages = 1;
      self.loading = false;
      return;
    }

    if(!self.recordSize) {
      self.recordSize = "25";
    }

    // Apply client-side sorting
    let sortedData = _.cloneDeep(self.tabledata);
    if(self.sortBy) {
      const sortParts = self.sortBy.split(',');
      const sortField = sortParts[0];
      const sortOrder = sortParts[1] || 'asc';
      
      sortedData = _.orderBy(sortedData, [sortField], [sortOrder]);
    }

    // Apply client-side pagination
    const totalElements = sortedData.length;
    const totalPages = Math.ceil(totalElements / parseInt(self.recordSize));
    const startIndex = self.pageNumber * parseInt(self.recordSize);
    const endIndex = startIndex + parseInt(self.recordSize);
    
    self.data = sortedData.slice(startIndex, endIndex);
    self.totalInvoiceCount = totalElements;
    self.pageSize = parseInt(self.recordSize);
    self.numPages = totalPages || 1;
    self.loading = false;

    // Update totalCount binding if provided
    if(self.totalCount !== undefined) {
      self.totalCount = totalElements;
    }

    // Sync column.order with current sortBy state
    if(self.sortBy && self.columns) {
      const sortParts = self.sortBy.split(',');
      const sortField = sortParts[0];
      const sortOrder = sortParts[1];
      
      self.columns.forEach(function(column) {
        const columnField = column.sortValue || column.value;
        if(columnField === sortField) {
          column.order = sortOrder;
        } else {
          column.order = null;
        }
      });
    }

    let idx = 0;
    self.data.forEach(function (record) {
      record.dataIndex = idx;
      idx++;
    });

    // Update select all state after loading data
    if(self.selectable) {
      self.updateSelectAllState();
    }
  }

  sort(column) {
    if(!column.order) {
      column.order = 'desc';
    }

    if(column.order === 'desc') {
      column.order = 'asc';
    } else {
      column.order = 'desc';
    }

    var sortKey = (column.sortValue !== undefined && column.sortValue !== null && String(column.sortValue).length > 0)
      ? String(column.sortValue)
      : column.value;
    this.sortBy = sortKey + ',' + column.order;

    this.pageNumber = 0;
    this.displayPageNumber = 1;
    this.loadData();
  }

  getSortIcon(column) {
    if(!column.sortable) {
      return '';
    }
    
    if(!this.sortBy) {
      return 'fa-sort';
    }
    
    const sortField = column.sortValue || column.value;
    const sortParts = this.sortBy.split(',');
    
    if(sortParts[0] === sortField) {
      // Column is currently sorted
      if(sortParts[1] === 'asc') {
        return 'fa-sort-up';
      } else {
        return 'fa-sort-down';
      }
    }
    
    // Column is not currently sorted
    return 'fa-sort';
  }

  getColumnCount() {
    let count = 0;
    if(this.columns) {
      this.columns.forEach(function(column) {
        if(this.hasPermissionToView(column)) {
          count++;
        }
      }.bind(this));
    }
    if(this.selectable) {
      count++;
    }
    return count;
  }

  /** Spring Page object (either the root GET body or nested under nestedPageKey, e.g. body.page). */
  resolveSpringPage(data) {
    if (!data) {
      return {};
    }
    const key = this.nestedPageKey;
    if (key && typeof key === 'string' && key.trim() && data[key] != null) {
      return data[key];
    }
    return data;
  }

  loadData() {
    let self = this;
    self.loading = true;

    if(!self.recordSize) {
      self.recordSize = "25";
    }

    // Handle client-side data if tabledata is provided and restUrl is empty
    if(self.tabledata && self.tabledata.length > 0 && (!self.restUrl || self.restUrl === '')) {
      self.loadClientSideData();
      return;
    }

    // Server-side data loading
    if(!self.restUrl || self.restUrl === '') {
      self.loading = false;
      self.data = [];
      self.numPages = 1;
      return;
    }

    let url = this.$rootScope.apiHost+"/api/"+this.restUrl+"?page="+this.pageNumber+"&size="+this.recordSize+"";

    if(this.sortBy) {
      url = url + "&sort="+this.sortBy;
    }

    if(this.filter) {
      url = url + "&" + this.filter();
    }

    this.$http.get(url, {withCredentials: true}).then(function (success) {
      const payload = success.data;
      const page = self.resolveSpringPage(payload);

      self.data = page.content || [];
      self.totalInvoiceCount = page.totalElements;
      self.pageNumber = page.number;
      self.pageSize = page.size;
      self.numPages = page.totalPages || 1; // Ensure at least 1 page even when no records
      self.loading = false;
      self.tabledata = self.data;

      if (self.onTableResponse && typeof self.onTableResponse === 'function') {
        self.onTableResponse({ response: payload });
      }

      // Update totalCount binding if provided
      if(self.totalCount !== undefined) {
        self.totalCount = page.totalElements;
      }

      // Sync column.order with current sortBy state
      if(self.sortBy && self.columns) {
        const sortParts = self.sortBy.split(',');
        const sortField = sortParts[0];
        const sortOrder = sortParts[1];
        
        self.columns.forEach(function(column) {
          const columnField = column.sortValue || column.value;
          if(columnField === sortField) {
            column.order = sortOrder;
          } else {
            column.order = null;
          }
        });
      }

      let idx = 0;
      self.data.forEach(function (record) {
        record.dataIndex = idx;
        idx++;
      });

      // Update select all state after loading data
      if(self.selectable) {
        self.updateSelectAllState();
      }

    });
  }

  toggleSelectAll() {
    let self = this;
    if(!this.selectable || !this.data) {
      return;
    }

    this.data.forEach(function(record) {
      if(record.selected !== self.allSelected) {
        record.selected = self.allSelected;
        if(self.selectFunction && typeof self.selectFunction === 'function') {
          self.selectFunction(record, record.selected);
        }
      }
    });
  }

  onRecordSelectionChange(record, selected) {
    // Call the original selectFunction if provided
    if(this.selectFunction && typeof this.selectFunction === 'function') {
      this.selectFunction(record, selected);
    }
    // Update select all state
    this.updateSelectAllState();
  }

  updateSelectAllState() {
    if(!this.selectable || !this.data || this.data.length === 0) {
      this.allSelected = false;
      this.someSelected = false;
      return;
    }

    let selectedCount = 0;
    this.data.forEach(function(record) {
      if(record.selected) {
        selectedCount++;
      }
    });

    this.allSelected = selectedCount === this.data.length;
    this.someSelected = selectedCount > 0 && selectedCount < this.data.length;
  }

  getRowClass(record) {
    if (this.rowClassFunction && typeof this.rowClassFunction === 'function') {
      return this.rowClassFunction(record);
    }
    return '';
  }

  parseData(record, column) {
    let columnIndex = [];

    if(column.value.includes('.')){
      columnIndex = column.value.split('.');
    } else {
      columnIndex.push(column.value)
    }

    let value = record;
    for(let i = 0; i < columnIndex.length; i++) {
      if(value === null || value === undefined) {
        value = '';
        break;
      }
      value = value[columnIndex[i]];
    }

    if(column.formatting) {
      value = column.formatting(record);
    }

    // Handle null/undefined values
    if(value === null || value === undefined) {
      value = '';
    }

    return this.$sce.trustAsHtml(value+'');
  }

  changeRecordSize() {
    this.loadData();
  }

  prevPage() {
    this.pageNumber = this.pageNumber - 1;
    this.displayPageNumber--;
    this.loadData();
  }

  nextPage() {
    this.pageNumber = this.pageNumber + 1;
    this.displayPageNumber++;
    if(this.pageNumber <= this.numPages) {
      this.loadData();
    }
  }

  hasPermissionToView(data) {
    if(data.secure === undefined) {
      return true;
    } else {
      return data.secure;
    }
  }

  getTotalSourceData() {
    if(this.tabledata && this.tabledata.length) {
      return this.tabledata;
    }

    return this.data || [];
  }

  shouldShowTotalsRow() {
    if (!this.showTotals || this.loading) {
      return false;
    }
    if (this.hasServerColumnTotals()) {
      return true;
    }
    return this.getTotalSourceData().length > 0;
  }

  hasServerColumnTotals() {
    return !!(this.serverColumnTotals && Object.keys(this.serverColumnTotals).length);
  }

  getServerColumnTotal(column) {
    if (!column || !column.value || !this.serverColumnTotals) {
      return null;
    }
    const value = this.serverColumnTotals[column.value];
    if (value === undefined || value === null || value === '') {
      return null;
    }
    const num = parseFloat(value);
    return isNaN(num) ? null : num;
  }

  getVisibleColumns() {
    let visible = [];

    if(!this.columns) {
      return visible;
    }

    this.columns.forEach(function(column) {
      if(this.hasPermissionToView(column)) {
        visible.push(column);
      }
    }.bind(this));

    return visible;
  }

  columnIncludesInTotal(column) {
    return column.dataType === 'number' || column.includeInTotal === true;
  }

  getNumericFieldValue(record, column) {
    const fieldPath = column.sortValue || column.value;

    if(!fieldPath) {
      return 0;
    }

    const parts = fieldPath.split('.');
    let value = record;

    for(let i = 0; i < parts.length; i++) {
      if(value == null) {
        return 0;
      }
      value = value[parts[i]];
    }

    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  }

  sumColumnTotal(column) {
    const serverTotal = this.getServerColumnTotal(column);
    if (serverTotal !== null) {
      return serverTotal;
    }

    let total = 0;

    this.getTotalSourceData().forEach(function(record) {
      total += this.getNumericFieldValue(record, column);
    }.bind(this));

    return total;
  }

  roundTotalValue(total) {
    return Math.round((total + Number.EPSILON) * 100) / 100;
  }

  formatColumnTotal(column) {
    let total = this.roundTotalValue(this.sumColumnTotal(column));

    if(column.formatting) {
      const fakeRecord = {};
      fakeRecord[column.value] = total;

      if(column.sortValue && column.sortValue !== column.value) {
        fakeRecord[column.sortValue] = total;
      }

      return column.formatting(fakeRecord);
    }

    return total.toFixed(2);
  }

  getTotalCellValue(column) {
    const visibleColumns = this.getVisibleColumns();

    if(!visibleColumns.length) {
      return '';
    }

    if(this.columnIncludesInTotal(column)) {
      return this.formatColumnTotal(column);
    }

    if(visibleColumns[0] === column) {
      return 'TOTAL:';
    }

    return '';
  }

  openFilter(column, event) {
    // Close other open filters
    this.columns.forEach(function(col) {
      if(col !== column) {
        col.showFilter = false;
      }
    });
    
    // Initialize filter search if not exists
    if(!column.filterSearch) {
      column.filterSearch = '';
    }
    
    // Toggle this filter
    column.showFilter = !column.showFilter;
    
    // Stop event propagation to prevent closing immediately
    if(event) {
      event.stopPropagation();
    }
  }

  getFilterSearchText(column) {
    const self = this;
    return function(option) {
      if(!column.filterSearch || column.filterSearch === '') {
        return true;
      }
      const searchText = column.filterSearch.toLowerCase();
      const optionText = (option.label || option.name || option || '').toLowerCase();
      return optionText.indexOf(searchText) !== -1;
    };
  }

  toggleFilterSelectAll(column, event) {
    if(!column || !column.filterOptions || column.filterOptions.length === 0) {
      return;
    }
    
    const allOption = column.filterOptions.find(function(opt) {
      return opt.id === 0 || opt.id === 'all';
    });
    
    if(!allOption) {
      return;
    }
    
    // ng-change fires after ng-model updates, so allOption.selected already has the new value
    const shouldSelectAll = allOption.selected;
    
    // Set all options to match the "All" option state
    column.filterOptions.forEach(function(option) {
      option.selected = shouldSelectAll;
    });
    
    // Update filter state to show badge count
    this.updateFilterState(column);
    
    // Automatically apply the filter
    this.applyFilterAuto(column);
  }

  updateFilterSelectAllState(column) {
    if(!column || !column.filterOptions || column.filterOptions.length === 0) {
      return;
    }
    
    const allOption = column.filterOptions.find(function(opt) {
      return opt.id === 0 || opt.id === 'all';
    });
    
    if(!allOption) {
      return;
    }
    
    // Count selected options (excluding "All" option)
    const selectedCount = column.filterOptions.filter(function(opt) {
      return opt.id !== 0 && opt.id !== 'all' && opt.selected;
    }).length;
    
    const totalCount = column.filterOptions.length - 1; // Exclude "All" option
    
    // Update "All" option state
    if(selectedCount === 0) {
      allOption.selected = false;
    } else if(selectedCount === totalCount) {
      allOption.selected = true;
    } else {
      // Indeterminate state - keep current state but could add visual indicator
      allOption.selected = false;
    }
    
    // Update filter state to show badge count
    this.updateFilterState(column);
    
    // Automatically apply the filter
    this.applyFilterAuto(column);
  }

  applyFilter(column) {
    if(column.filterFunction && typeof column.filterFunction === 'function') {
      column.filterFunction(column);
    }
    this.updateFilterState(column);
    column.showFilter = false;
    this.loadData();
  }

  applyFilterAuto(column) {
    const self = this;
    // Clear any existing timeout for this column
    if(column.filterTimeout) {
      clearTimeout(column.filterTimeout);
    }
    
    // Debounce the filter application to avoid too many rapid API calls
    column.filterTimeout = setTimeout(function() {
      if(column.filterFunction && typeof column.filterFunction === 'function') {
        column.filterFunction(column);
      }
      self.updateFilterState(column);
      self.loadData();
    }, 300); // 300ms delay
  }

  clearFilter(column) {
    if(column.filterOptions) {
      column.filterOptions.forEach(function(option) {
        option.selected = true;
      });
    }
    if(column.filterSearch) {
      column.filterSearch = '';
    }
    if(column.filterFunction && typeof column.filterFunction === 'function') {
      column.filterFunction(column);
    }
    this.updateFilterState(column);
    column.showFilter = false;
    this.loadData();
  }

  updateFilterState(column) {
    if(column.filterType === 'dateRange') {
      // For date range filters, check if either date is set
      column.hasActiveFilter = !!(column.dateFrom || column.dateTo);
      column.filteredCount = null; // Don't show count for date filters
    } else if(column.filterOptions) {
      const allOption = column.filterOptions.find(function(opt) {
        return opt.id === 0 || opt.id === 'all';
      });
      
      // Count selected options (excluding "All" option if it exists)
      const selectedCount = column.filterOptions.filter(function(opt) {
        return opt.id !== 0 && opt.id !== 'all' && opt.selected;
      }).length;
      
      const totalCount = column.filterOptions.length - (allOption ? 1 : 0); // Exclude "All" option from total
      
      column.hasActiveFilter = selectedCount < totalCount;
      
      // Set filtered count for display (only show if not all are selected)
      if(column.hasActiveFilter && selectedCount > 0) {
        column.filteredCount = selectedCount;
      } else {
        column.filteredCount = null;
      }
    } else {
      column.hasActiveFilter = false;
      column.filteredCount = null;
    }
  }

  applyDateFilter(column) {
    const self = this;
    // Clear any existing timeout for this column
    if(column.filterTimeout) {
      clearTimeout(column.filterTimeout);
    }
    
    // Debounce the filter application to avoid too many rapid API calls
    column.filterTimeout = setTimeout(function() {
      if(column.filterFunction && typeof column.filterFunction === 'function') {
        column.filterFunction(column);
      }
      self.updateFilterState(column);
      self.pageNumber = 0;
      self.displayPageNumber = 1;
      self.loadData();
    }, 300); // 300ms delay
  }

  clearDateFilter(column) {
    column.dateFrom = null;
    column.dateTo = null;
    if(column.filterFunction && typeof column.filterFunction === 'function') {
      column.filterFunction(column);
    }
    this.updateFilterState(column);
    this.pageNumber = 0;
    this.displayPageNumber = 1;
    this.loadData();
  }

  exportToSpreadsheet(format = 'xlsx') {
    let self = this;
    
    // Check if export is enabled (defaults to true if not specified)
    if (this.exportEnabled === false) {
      return;
    }
    
    self.exporting = true;

    this.loadRecordsForExport().then(function (allRecords) {
      // Prepare headers
      let headers = [];
      let numericColumnIndices = [];
      self.columns.forEach(function(column, index) {
        if (self.hasPermissionToView(column)) {
          headers.push(column.displayName);
          if (column.dataType === 'number') {
            numericColumnIndices.push(headers.length - 1);
          }
        }
      });

      // Prepare data rows and calculate totals
      let rows = [];
      let totals = [];
      let visibleColumnIndex = 0;
      self.columns.forEach(function(column, colIndex) {
        if (self.hasPermissionToView(column)) {
          totals.push(0); // Initialize totals array
          visibleColumnIndex++;
        }
      });

      allRecords.forEach(function(record) {
        let row = [];
        visibleColumnIndex = 0;
        self.columns.forEach(function(column, colIndex) {
          if (!self.hasPermissionToView(column)) {
            return; // Skip hidden columns
          }
          
          let value = '';
          
          // For numeric columns, extract raw numeric value
          if (column.dataType === 'number') {
            // Get the raw numeric value from the record
            let fieldPath = column.sortValue || column.value;
            let rawValue = null;
            
            if (fieldPath) {
              let parts = fieldPath.split('.');
              rawValue = record;
              for (let i = 0; i < parts.length; i++) {
                if (rawValue && rawValue[parts[i]] !== undefined) {
                  rawValue = rawValue[parts[i]];
                } else {
                  rawValue = null;
                  break;
                }
              }
            }
            
            // If sortValue path didn't work, try the value path
            if (rawValue === null && column.value && column.value !== fieldPath) {
              let parts = column.value.split('.');
              rawValue = record;
              for (let i = 0; i < parts.length; i++) {
                if (rawValue && rawValue[parts[i]] !== undefined) {
                  rawValue = rawValue[parts[i]];
                } else {
                  rawValue = null;
                  break;
                }
              }
            }
            
            // If still null, check what the formatting function uses
            if (rawValue === null && column.formatting) {
              // Try common numeric fields
              if (record.yearlyRevenue !== undefined) {
                rawValue = record.yearlyRevenue;
              } else if (record.allTimeRevenue !== undefined) {
                rawValue = record.allTimeRevenue;
              }
            }
            
            // Convert to number
            if (rawValue === null || rawValue === undefined || rawValue === '') {
              value = null;
            } else {
              let numValue = parseFloat(rawValue);
              value = isNaN(numValue) ? null : numValue;
              // Add to totals if valid number
              if (value !== null) {
                totals[visibleColumnIndex] += value;
              }
            }
          } else {
            // For non-numeric columns, use formatting function if available
            if (column.formatting) {
              let formatted = column.formatting(record);
              // Remove HTML tags (like links)
              value = formatted.replace(/<[^>]*>/g, '').trim();
              
              // If empty after stripping HTML, try to get raw value
              if (!value) {
                // Try common field names first
                if (record.contractName) {
                  value = record.contractName;
                } else if (column.value) {
                  let parts = column.value.split('.');
                  let rawValue = record;
                  for (let i = 0; i < parts.length; i++) {
                    if (rawValue && rawValue[parts[i]] !== undefined) {
                      rawValue = rawValue[parts[i]];
                    } else {
                      rawValue = null;
                      break;
                    }
                  }
                  value = rawValue || '';
                }
              }
            } else {
              // No formatting function, get raw value
              let parts = column.value.split('.');
              let rawValue = record;
              for (let i = 0; i < parts.length; i++) {
                if (rawValue && rawValue[parts[i]] !== undefined) {
                  rawValue = rawValue[parts[i]];
                } else {
                  rawValue = null;
                  break;
                }
              }
              value = rawValue || '';
            }
          }
          
          row.push(value);
          visibleColumnIndex++;
        });
        rows.push(row);
      });

      // Add totals row
      let totalsRow = [];
      visibleColumnIndex = 0;
      self.columns.forEach(function(column, colIndex) {
        if (!self.hasPermissionToView(column)) {
          return;
        }
        if (column.dataType === 'number') {
          totalsRow.push(totals[visibleColumnIndex]);
        } else {
          // For non-numeric columns, use "Total" for first column, empty for others
          totalsRow.push(visibleColumnIndex === 0 ? 'Total' : '');
        }
        visibleColumnIndex++;
      });
      rows.push(totalsRow);

      // Create worksheet
      let worksheetData = [headers].concat(rows);
      let worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

      // Style header row (bold and centered)
      if (format !== 'csv') {
        // Excel supports styling
        let headerRange = XLSX.utils.decode_range(worksheet['!ref']);
        for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
          let cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
          if (!worksheet[cellAddress]) continue;
          
          // Set cell style
          worksheet[cellAddress].s = {
            font: { bold: true },
            alignment: { horizontal: 'center', vertical: 'center' }
          };
        }
        
        // Style totals row (bold)
        let totalsRowIndex = rows.length;
        for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
          let cellAddress = XLSX.utils.encode_cell({ r: totalsRowIndex, c: col });
          if (worksheet[cellAddress]) {
            if (!worksheet[cellAddress].s) {
              worksheet[cellAddress].s = {};
            }
            worksheet[cellAddress].s.font = { bold: true };
          }
        }
      }

      // Set column widths
      let columnWidths = [];
      headers.forEach(function() {
        columnWidths.push({ wch: 20 });
      });
      worksheet['!cols'] = columnWidths;

      // Create workbook
      let workbook = XLSX.utils.book_new();
      let sheetName = self.exportFileName || "Data";
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

      // Generate filename
      let baseFileName = self.exportFileName || 'export';
      let filename = baseFileName + '_' + moment().format("MMDDYYYY") + '.' + format;

      // Export
      if (format === 'csv') {
        // For CSV, convert to CSV string and download
        let csv = XLSX.utils.sheet_to_csv(worksheet);
        let blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        let link = document.createElement('a');
        let downloadUrl = URL.createObjectURL(blob);
        link.setAttribute('href', downloadUrl);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        // For Excel
        XLSX.writeFile(workbook, filename);
      }

      self.exporting = false;
      if (self.toastr) {
        self.toastr.success("Data exported successfully", "Export Complete");
      }
    }, function(error) {
      self.exporting = false;
      if (self.toastr) {
        self.toastr.error("Failed to export data", "Export Error");
      }
    });
  }

  /**
   * Server-backed tables fetch all pages for export.
   * Client-side tables (empty restUrl + tabledata) export the in-memory rows.
   */
  loadRecordsForExport() {
    if (!this.restUrl || this.restUrl === '') {
      let records = _.cloneDeep(this.tabledata || []);
      if (this.sortBy) {
        const sortParts = this.sortBy.split(',');
        const sortField = sortParts[0];
        const sortOrder = sortParts[1] || 'asc';
        records = _.orderBy(records, [sortField], [sortOrder]);
      }
      return this.$q.when(records);
    }

    let url = this.$rootScope.apiHost + "/api/" + this.restUrl + "?page=0&size=10000";

    if (this.sortBy) {
      url = url + "&sort=" + this.sortBy;
    }

    if (this.filter) {
      url = url + "&" + this.filter();
    }

    let self = this;
    return this.$http.get(url, {withCredentials: true}).then(function (success) {
      let page = self.resolveSpringPage(success.data);
      return page.content || [];
    });
  }

  exportToExcel() {
    this.exportToSpreadsheet('xlsx');
  }

  exportToCsv() {
    this.exportToSpreadsheet('csv');
  }

}

export default SpringDataTableController;



// WEBPACK FOOTER //
// ./client/common/springDataTable/springDataTable.controller.js